import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/utils/http'

Vue.use(Vuex)

const state = {
	dash: {},
	chan: {}
}

const mutations = {
	setDash(state, payload) {
		state.dash = payload
	},
	setChan(state, payload) {
    if (Object.keys(payload).length == 0) {
      state.chan = {};
      return;
    }
    state.chan = Object.assign({}, state.chan, payload);
	}
}

const actions = {
	loadDash({commit}) {
		return new Promise(resolve => {
			http.post('/api/dash/').then(resp => {
				if (resp.code == 0) {
					commit('setDash', resp.data)
				}
				resolve(resp)
			})
		})
	},
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
